export function getDogs(name) {
  let data = {};
  return function (dispatch) {
    return fetch(
      `https://wikidog-wenceslaorojas.herokuapp.com/dogs?name=${name}`
    )
      .then((response) => response.json())
      .then((jsonDog) => {
        if (jsonDog.length > 0) {
          data = {
            dogs: jsonDog,
          };
        } else {
          dispatch({ type: "NOT_FOUND" });
        }
      })
      .then(() => {
        fetch(`https://wikidog-wenceslaorojas.herokuapp.com/temperament`)
          .then((response) => response.json())
          .then((jsonTemps) => {
            data = {
              ...data,
              temperamentos: jsonTemps,
            };
            dispatch({ type: "PRECARGA", payload: data });
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        dispatch({ type: "NOT_FOUND" });
      });
  };
}
export function getDetailDog(name) {
  return function (dispatch) {
    return fetch(`https://wikidog-wenceslaorojas.herokuapp.com/dog/${name}`)
      .then((response) => response.json())
      .then((json) => {
        dispatch({ type: "DETAIL_DOG", payload: json });
      })
      .catch((err) => {
        console.error(err);
      });
  };
}
export function agregarPerro(data) {
  fetch("https://wikidog-wenceslaorojas.herokuapp.com/dog", {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).catch((err) => console.error(err));
}

export function orderBY(value) {
  return { type: "ORDER_BY", payload: value };
}

export function FiltrarPorTemperamento(value) {
  return { type: "FILTRAR_POR_TEMPERAMENTO", payload: value };
}
export function FiltrarPorRaza(value) {
  return { type: "FILTRAR_RAZA_O_CREADA", payload: value };
}

export function resetDog() {
  return { type: "DETAIL_DOG", payload: {} };
}
